import React from "react";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import MutationErrorAlert from "./MutationErrorAlert";

// EMAILS-IMPL-007: shared Create/Edit dialog shell used by all four
// authoring panels (Program/Campaign/Angle/Audience Definition) -- the
// modal chrome, submit/cancel buttons, pending state, and error display are
// identical across all four; only the form fields inside differ, so those
// are passed as `children` rather than duplicated four times.
export default function EntityFormDialog({
  open,
  onOpenChange,
  title,
  description,
  onSubmit,
  submitting,
  error,
  submitLabel = "Save",
  testId,
  children,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-white/10 bg-slate-950 text-slate-100 sm:max-w-lg" data-testid={testId}>
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle className="text-slate-100">{title}</DialogTitle>
            {description ? <DialogDescription className="text-slate-400">{description}</DialogDescription> : null}
          </DialogHeader>

          <div className="space-y-4 py-4">
            {children}
            <MutationErrorAlert error={error} testId={`${testId}-error`} />
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="ghost"
              className="text-slate-300"
              onClick={() => onOpenChange(false)}
              disabled={submitting}
              data-testid={`${testId}-cancel`}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-violet-600 text-white hover:bg-violet-500"
              disabled={submitting}
              data-testid={`${testId}-submit`}
            >
              {submitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              {submitLabel}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
